@file:OptIn(InternalResourceApi::class)

package banko.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/banko.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_488_561_084)
public val Res.string.add_bot: StringResource by lazy {
      StringResource("string:add_bot", "add_bot", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 27),
      ))
    }

@delegate:ResourceContentHash(2_067_627_312)
public val Res.string.add_player: StringResource by lazy {
      StringResource("string:add_player", "add_player", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38, 34),
      ))
    }

@delegate:ResourceContentHash(1_256_739_046)
public val Res.string.ads_removed: StringResource by lazy {
      StringResource("string:ads_removed", "ads_removed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73, 35),
      ))
    }

@delegate:ResourceContentHash(1_012_972_554)
public val Res.string.age_days: StringResource by lazy {
      StringResource("string:age_days", "age_days", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109, 36),
      ))
    }

@delegate:ResourceContentHash(1_400_681_093)
public val Res.string.age_months: StringResource by lazy {
      StringResource("string:age_months", "age_months", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146, 34),
      ))
    }

@delegate:ResourceContentHash(-120_496_940)
public val Res.string.age_today: StringResource by lazy {
      StringResource("string:age_today", "age_today", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181, 25),
      ))
    }

@delegate:ResourceContentHash(1_178_293_861)
public val Res.string.age_weeks: StringResource by lazy {
      StringResource("string:age_weeks", "age_weeks", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207, 33),
      ))
    }

@delegate:ResourceContentHash(-266_151_403)
public val Res.string.age_years: StringResource by lazy {
      StringResource("string:age_years", "age_years", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241, 33),
      ))
    }

@delegate:ResourceContentHash(-909_857_306)
public val Res.string.age_yesterday: StringResource by lazy {
      StringResource("string:age_yesterday", "age_yesterday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275, 33),
      ))
    }

@delegate:ResourceContentHash(1_395_973_580)
public val Res.string.app_tagline: StringResource by lazy {
      StringResource("string:app_tagline", "app_tagline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309, 55),
      ))
    }

@delegate:ResourceContentHash(1_882_219_717)
public val Res.string.award_bust_magnet: StringResource by lazy {
      StringResource("string:award_bust_magnet", "award_bust_magnet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 438, 41),
      ))
    }

@delegate:ResourceContentHash(-1_616_494_773)
public val Res.string.award_bust_magnet_detail: StringResource by lazy {
      StringResource("string:award_bust_magnet_detail", "award_bust_magnet_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 365, 72),
      ))
    }

@delegate:ResourceContentHash(-419_645_910)
public val Res.string.award_doubles_dealer: StringResource by lazy {
      StringResource("string:award_doubles_dealer", "award_doubles_dealer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 544, 48),
      ))
    }

@delegate:ResourceContentHash(-23_046_918)
public val Res.string.award_doubles_dealer_detail: StringResource by lazy {
      StringResource("string:award_doubles_dealer_detail", "award_doubles_dealer_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 480, 63),
      ))
    }

@delegate:ResourceContentHash(-1_954_336_152)
public val Res.string.award_escape_artist: StringResource by lazy {
      StringResource("string:award_escape_artist", "award_escape_artist", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 664, 47),
      ))
    }

@delegate:ResourceContentHash(1_422_322_882)
public val Res.string.award_escape_artist_detail: StringResource by lazy {
      StringResource("string:award_escape_artist_detail", "award_escape_artist_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 593, 70),
      ))
    }

@delegate:ResourceContentHash(898_916_121)
public val Res.string.award_iron_nerves: StringResource by lazy {
      StringResource("string:award_iron_nerves", "award_iron_nerves", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 793, 41),
      ))
    }

@delegate:ResourceContentHash(1_895_576_722)
public val Res.string.award_iron_nerves_detail: StringResource by lazy {
      StringResource("string:award_iron_nerves_detail", "award_iron_nerves_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 712, 80),
      ))
    }

@delegate:ResourceContentHash(2_010_082_028)
public val Res.string.award_safe_hands: StringResource by lazy {
      StringResource("string:award_safe_hands", "award_safe_hands", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 915, 40),
      ))
    }

@delegate:ResourceContentHash(1_895_576_722)
public val Res.string.award_safe_hands_detail: StringResource by lazy {
      StringResource("string:award_safe_hands_detail", "award_safe_hands_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 835, 79),
      ))
    }

@delegate:ResourceContentHash(-507_690_378)
public val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 992, 20),
      ))
    }

@delegate:ResourceContentHash(-1_007_553_603)
public val Res.string.back_navigation: StringResource by lazy {
      StringResource("string:back_navigation", "back_navigation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 956, 35),
      ))
    }

@delegate:ResourceContentHash(1_592_863_297)
public val Res.string.banko_button: StringResource by lazy {
      StringResource("string:banko_button", "banko_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1013, 32),
      ))
    }

@delegate:ResourceContentHash(-2_080_820_125)
public val Res.string.banko_for_players: StringResource by lazy {
      StringResource("string:banko_for_players", "banko_for_players", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1046, 45),
      ))
    }

@delegate:ResourceContentHash(1_247_714_358)
public val Res.string.banko_for_selected_players: StringResource by lazy {
      StringResource("string:banko_for_selected_players", "banko_for_selected_players", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1092, 74),
      ))
    }

@delegate:ResourceContentHash(-177_167_445)
public val Res.string.banko_plus_active: StringResource by lazy {
      StringResource("string:banko_plus_active", "banko_plus_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1167, 93),
      ))
    }

@delegate:ResourceContentHash(1_438_278_545)
public val Res.string.banko_plus_annual_with_price: StringResource by lazy {
      StringResource("string:banko_plus_annual_with_price", "banko_plus_annual_with_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1261, 68),
      ))
    }

@delegate:ResourceContentHash(-112_908_705)
public val Res.string.banko_plus_badge: StringResource by lazy {
      StringResource("string:banko_plus_badge", "banko_plus_badge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1330, 32),
      ))
    }

@delegate:ResourceContentHash(1_978_903_786)
public val Res.string.banko_plus_banner: StringResource by lazy {
      StringResource("string:banko_plus_banner", "banko_plus_banner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1363, 41),
      ))
    }

@delegate:ResourceContentHash(1_938_998_633)
public val Res.string.banko_plus_current_plan: StringResource by lazy {
      StringResource("string:banko_plus_current_plan", "banko_plus_current_plan", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1405, 55),
      ))
    }

@delegate:ResourceContentHash(1_064_277_241)
public val Res.string.banko_plus_monthly_plan: StringResource by lazy {
      StringResource("string:banko_plus_monthly_plan", "banko_plus_monthly_plan", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1461, 43),
      ))
    }

@delegate:ResourceContentHash(1_617_505_265)
public val Res.string.banko_plus_plan_unknown: StringResource by lazy {
      StringResource("string:banko_plus_plan_unknown", "banko_plus_plan_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1505, 39),
      ))
    }

@delegate:ResourceContentHash(-663_926_070)
public val Res.string.banko_plus_status_note: StringResource by lazy {
      StringResource("string:banko_plus_status_note", "banko_plus_status_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1545, 90),
      ))
    }

@delegate:ResourceContentHash(-1_733_259_969)
public val Res.string.banko_plus_status_title: StringResource by lazy {
      StringResource("string:banko_plus_status_title", "banko_plus_status_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1636, 59),
      ))
    }

@delegate:ResourceContentHash(-1_882_618_130)
public val Res.string.banko_plus_unlocks_game_length: StringResource by lazy {
      StringResource("string:banko_plus_unlocks_game_length", "banko_plus_unlocks_game_length", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1696, 106),
      ))
    }

@delegate:ResourceContentHash(-53_092_831)
public val Res.string.banko_plus_with_price: StringResource by lazy {
      StringResource("string:banko_plus_with_price", "banko_plus_with_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1803, 65),
      ))
    }

@delegate:ResourceContentHash(-529_703_591)
public val Res.string.banko_plus_yearly_plan: StringResource by lazy {
      StringResource("string:banko_plus_yearly_plan", "banko_plus_yearly_plan", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1869, 38),
      ))
    }

@delegate:ResourceContentHash(-491_619_057)
public val Res.string.banko_rules_title: StringResource by lazy {
      StringResource("string:banko_rules_title", "banko_rules_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1908, 45),
      ))
    }

@delegate:ResourceContentHash(1_592_863_297)
public val Res.string.banko_title: StringResource by lazy {
      StringResource("string:banko_title", "banko_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1954, 31),
      ))
    }

@delegate:ResourceContentHash(32_462_453)
public val Res.string.benefit_host_length: StringResource by lazy {
      StringResource("string:benefit_host_length", "benefit_host_length", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1986, 67),
      ))
    }

@delegate:ResourceContentHash(-565_361_986)
public val Res.string.benefit_lobby_ad_free: StringResource by lazy {
      StringResource("string:benefit_lobby_ad_free", "benefit_lobby_ad_free", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2054, 65),
      ))
    }

@delegate:ResourceContentHash(-900_919_919)
public val Res.string.benefit_own_ads: StringResource by lazy {
      StringResource("string:benefit_own_ads", "benefit_own_ads", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2120, 55),
      ))
    }

@delegate:ResourceContentHash(677_775_266)
public val Res.string.benefit_plus_dice: StringResource by lazy {
      StringResource("string:benefit_plus_dice", "benefit_plus_dice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2176, 61),
      ))
    }

@delegate:ResourceContentHash(1_256_242_788)
public val Res.string.benefit_plus_everything: StringResource by lazy {
      StringResource("string:benefit_plus_everything", "benefit_plus_everything", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2238, 59),
      ))
    }

@delegate:ResourceContentHash(1_011_938_025)
public val Res.string.benefit_silver_dice: StringResource by lazy {
      StringResource("string:benefit_silver_dice", "benefit_silver_dice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2298, 55),
      ))
    }

@delegate:ResourceContentHash(-861_499_690)
public val Res.string.biggest_bust: StringResource by lazy {
      StringResource("string:biggest_bust", "biggest_bust", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2354, 36),
      ))
    }

@delegate:ResourceContentHash(-848_665_429)
public val Res.string.biggest_pot: StringResource by lazy {
      StringResource("string:biggest_pot", "biggest_pot", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2391, 35),
      ))
    }

@delegate:ResourceContentHash(-1_396_430_872)
public val Res.string.boldest_bank: StringResource by lazy {
      StringResource("string:boldest_bank", "boldest_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2427, 36),
      ))
    }

@delegate:ResourceContentHash(2_029_073_158)
public val Res.string.bust_risk_description: StringResource by lazy {
      StringResource("string:bust_risk_description", "bust_risk_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2464, 77),
      ))
    }

@delegate:ResourceContentHash(1_440_214_369)
public val Res.string.bust_risk_live: StringResource by lazy {
      StringResource("string:bust_risk_live", "bust_risk_live", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2542, 42),
      ))
    }

@delegate:ResourceContentHash(-1_432_452_076)
public val Res.string.bust_risk_safe: StringResource by lazy {
      StringResource("string:bust_risk_safe", "bust_risk_safe", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2585, 54),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
public val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2640, 22),
      ))
    }

@delegate:ResourceContentHash(1_075_823_529)
public val Res.string.career_avg_score: StringResource by lazy {
      StringResource("string:career_avg_score", "career_avg_score", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2663, 36),
      ))
    }

@delegate:ResourceContentHash(1_889_967_777)
public val Res.string.career_best_bank: StringResource by lazy {
      StringResource("string:career_best_bank", "career_best_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2700, 36),
      ))
    }

@delegate:ResourceContentHash(-1_549_181_721)
public val Res.string.career_best_score: StringResource by lazy {
      StringResource("string:career_best_score", "career_best_score", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2737, 41),
      ))
    }

@delegate:ResourceContentHash(-1_033_225_275)
public val Res.string.career_best_streak: StringResource by lazy {
      StringResource("string:career_best_streak", "career_best_streak", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2779, 42),
      ))
    }

@delegate:ResourceContentHash(-1_828_433_266)
public val Res.string.career_bust_rate: StringResource by lazy {
      StringResource("string:career_bust_rate", "career_bust_rate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2822, 96),
      ))
    }

@delegate:ResourceContentHash(1_929_643_922)
public val Res.string.career_device_note: StringResource by lazy {
      StringResource("string:career_device_note", "career_device_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2919, 102),
      ))
    }

@delegate:ResourceContentHash(-414_385_121)
public val Res.string.career_empty_body: StringResource by lazy {
      StringResource("string:career_empty_body", "career_empty_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3022, 181),
      ))
    }

@delegate:ResourceContentHash(-1_488_386_126)
public val Res.string.career_empty_title: StringResource by lazy {
      StringResource("string:career_empty_title", "career_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3204, 42),
      ))
    }

@delegate:ResourceContentHash(1_392_292_458)
public val Res.string.career_form_hint: StringResource by lazy {
      StringResource("string:career_form_hint", "career_form_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3247, 68),
      ))
    }

@delegate:ResourceContentHash(421_007_708)
public val Res.string.career_games: StringResource by lazy {
      StringResource("string:career_games", "career_games", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3316, 28),
      ))
    }

@delegate:ResourceContentHash(1_202_766_568)
public val Res.string.career_history_margin: StringResource by lazy {
      StringResource("string:career_history_margin", "career_history_margin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3345, 41),
      ))
    }

@delegate:ResourceContentHash(732_894_869)
public val Res.string.career_history_meta_local: StringResource by lazy {
      StringResource("string:career_history_meta_local", "career_history_meta_local", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3387, 81),
      ))
    }

@delegate:ResourceContentHash(-1_972_192_462)
public val Res.string.career_history_meta_online: StringResource by lazy {
      StringResource("string:career_history_meta_online", "career_history_meta_online", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3469, 74),
      ))
    }

@delegate:ResourceContentHash(-1_131_416_364)
public val Res.string.career_history_place: StringResource by lazy {
      StringResource("string:career_history_place", "career_history_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3544, 60),
      ))
    }

@delegate:ResourceContentHash(-795_850_670)
public val Res.string.career_history_win: StringResource by lazy {
      StringResource("string:career_history_win", "career_history_win", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3659, 54),
      ))
    }

@delegate:ResourceContentHash(-1_724_878_482)
public val Res.string.career_history_winner: StringResource by lazy {
      StringResource("string:career_history_winner", "career_history_winner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3605, 53),
      ))
    }

@delegate:ResourceContentHash(-952_949_146)
public val Res.string.career_luck_doubles: StringResource by lazy {
      StringResource("string:career_luck_doubles", "career_luck_doubles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3714, 63),
      ))
    }

@delegate:ResourceContentHash(1_651_971_831)
public val Res.string.career_luck_fair: StringResource by lazy {
      StringResource("string:career_luck_fair", "career_luck_fair", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3778, 52),
      ))
    }

@delegate:ResourceContentHash(-501_030_725)
public val Res.string.career_luck_needs_rolls: StringResource by lazy {
      StringResource("string:career_luck_needs_rolls", "career_luck_needs_rolls", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3831, 95),
      ))
    }

@delegate:ResourceContentHash(1_047_932_565)
public val Res.string.career_luck_sevens: StringResource by lazy {
      StringResource("string:career_luck_sevens", "career_luck_sevens", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3927, 62),
      ))
    }

@delegate:ResourceContentHash(411_921_989)
public val Res.string.career_luck_verdict_fair: StringResource by lazy {
      StringResource("string:career_luck_verdict_fair", "career_luck_verdict_fair", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3990, 76),
      ))
    }

@delegate:ResourceContentHash(-66_201_270)
public val Res.string.career_luck_verdict_lucky: StringResource by lazy {
      StringResource("string:career_luck_verdict_lucky", "career_luck_verdict_lucky", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4067, 57),
      ))
    }

@delegate:ResourceContentHash(1_265_887_662)
public val Res.string.career_luck_verdict_unlucky: StringResource by lazy {
      StringResource("string:career_luck_verdict_unlucky", "career_luck_verdict_unlucky", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4125, 63),
      ))
    }

@delegate:ResourceContentHash(-798_200_822)
public val Res.string.career_reset: StringResource by lazy {
      StringResource("string:career_reset", "career_reset", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4422, 36),
      ))
    }

@delegate:ResourceContentHash(-1_680_225_485)
public val Res.string.career_reset_cancel: StringResource by lazy {
      StringResource("string:career_reset_cancel", "career_reset_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4189, 35),
      ))
    }

@delegate:ResourceContentHash(-1_653_778_586)
public val Res.string.career_reset_confirm: StringResource by lazy {
      StringResource("string:career_reset_confirm", "career_reset_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4225, 36),
      ))
    }

@delegate:ResourceContentHash(-103_493_370)
public val Res.string.career_reset_message: StringResource by lazy {
      StringResource("string:career_reset_message", "career_reset_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4262, 108),
      ))
    }

@delegate:ResourceContentHash(539_148_449)
public val Res.string.career_reset_title: StringResource by lazy {
      StringResource("string:career_reset_title", "career_reset_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4371, 50),
      ))
    }

@delegate:ResourceContentHash(2_135_462_003)
public val Res.string.career_rival_record: StringResource by lazy {
      StringResource("string:career_rival_record", "career_rival_record", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4459, 63),
      ))
    }

@delegate:ResourceContentHash(298_509_272)
public val Res.string.career_rivals_empty: StringResource by lazy {
      StringResource("string:career_rivals_empty", "career_rivals_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4523, 83),
      ))
    }

@delegate:ResourceContentHash(703_168_640)
public val Res.string.career_rivals_legend_them: StringResource by lazy {
      StringResource("string:career_rivals_legend_them", "career_rivals_legend_them", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4607, 61),
      ))
    }

@delegate:ResourceContentHash(1_300_554_441)
public val Res.string.career_rivals_legend_you: StringResource by lazy {
      StringResource("string:career_rivals_legend_you", "career_rivals_legend_you", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4669, 56),
      ))
    }

@delegate:ResourceContentHash(-1_408_012_724)
public val Res.string.career_scores_legend_other: StringResource by lazy {
      StringResource("string:career_scores_legend_other", "career_scores_legend_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4726, 50),
      ))
    }

@delegate:ResourceContentHash(2_613_541)
public val Res.string.career_scores_legend_win: StringResource by lazy {
      StringResource("string:career_scores_legend_win", "career_scores_legend_win", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4777, 36),
      ))
    }

@delegate:ResourceContentHash(-1_798_657_902)
public val Res.string.career_scores_selected: StringResource by lazy {
      StringResource("string:career_scores_selected", "career_scores_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4814, 74),
      ))
    }

@delegate:ResourceContentHash(1_680_165_909)
public val Res.string.career_section_form: StringResource by lazy {
      StringResource("string:career_section_form", "career_section_form", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4889, 43),
      ))
    }

@delegate:ResourceContentHash(-164_665_879)
public val Res.string.career_section_history: StringResource by lazy {
      StringResource("string:career_section_history", "career_section_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4933, 46),
      ))
    }

@delegate:ResourceContentHash(1_486_382_452)
public val Res.string.career_section_luck: StringResource by lazy {
      StringResource("string:career_section_luck", "career_section_luck", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4980, 39),
      ))
    }

@delegate:ResourceContentHash(-983_542_102)
public val Res.string.career_section_placements: StringResource by lazy {
      StringResource("string:career_section_placements", "career_section_placements", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5020, 45),
      ))
    }

@delegate:ResourceContentHash(-1_090_460_258)
public val Res.string.career_section_rivals: StringResource by lazy {
      StringResource("string:career_section_rivals", "career_section_rivals", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5066, 37),
      ))
    }

@delegate:ResourceContentHash(-216_143_578)
public val Res.string.career_section_scores: StringResource by lazy {
      StringResource("string:career_section_scores", "career_section_scores", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5104, 49),
      ))
    }

@delegate:ResourceContentHash(-1_250_783_746)
public val Res.string.career_section_style: StringResource by lazy {
      StringResource("string:career_section_style", "career_section_style", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5154, 48),
      ))
    }

@delegate:ResourceContentHash(866_249_655)
public val Res.string.career_style_body: StringResource by lazy {
      StringResource("string:career_style_body", "career_style_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5203, 121),
      ))
    }

@delegate:ResourceContentHash(-1_271_380_849)
public val Res.string.career_style_scale_high: StringResource by lazy {
      StringResource("string:career_style_scale_high", "career_style_scale_high", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5325, 43),
      ))
    }

@delegate:ResourceContentHash(-1_344_839_139)
public val Res.string.career_style_scale_low: StringResource by lazy {
      StringResource("string:career_style_scale_low", "career_style_scale_low", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5369, 42),
      ))
    }

@delegate:ResourceContentHash(-2_134_894_963)
public val Res.string.career_win_rate: StringResource by lazy {
      StringResource("string:career_win_rate", "career_win_rate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5412, 35),
      ))
    }

@delegate:ResourceContentHash(927_059_128)
public val Res.string.career_win_streak: StringResource by lazy {
      StringResource("string:career_win_streak", "career_win_streak", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5448, 41),
      ))
    }

@delegate:ResourceContentHash(-108_556_871)
public val Res.string.career_wins: StringResource by lazy {
      StringResource("string:career_wins", "career_wins", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5490, 27),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_bot", Res.string.add_bot)
  map.put("add_player", Res.string.add_player)
  map.put("ads_removed", Res.string.ads_removed)
  map.put("age_days", Res.string.age_days)
  map.put("age_months", Res.string.age_months)
  map.put("age_today", Res.string.age_today)
  map.put("age_weeks", Res.string.age_weeks)
  map.put("age_years", Res.string.age_years)
  map.put("age_yesterday", Res.string.age_yesterday)
  map.put("app_tagline", Res.string.app_tagline)
  map.put("award_bust_magnet", Res.string.award_bust_magnet)
  map.put("award_bust_magnet_detail", Res.string.award_bust_magnet_detail)
  map.put("award_doubles_dealer", Res.string.award_doubles_dealer)
  map.put("award_doubles_dealer_detail", Res.string.award_doubles_dealer_detail)
  map.put("award_escape_artist", Res.string.award_escape_artist)
  map.put("award_escape_artist_detail", Res.string.award_escape_artist_detail)
  map.put("award_iron_nerves", Res.string.award_iron_nerves)
  map.put("award_iron_nerves_detail", Res.string.award_iron_nerves_detail)
  map.put("award_safe_hands", Res.string.award_safe_hands)
  map.put("award_safe_hands_detail", Res.string.award_safe_hands_detail)
  map.put("back", Res.string.back)
  map.put("back_navigation", Res.string.back_navigation)
  map.put("banko_button", Res.string.banko_button)
  map.put("banko_for_players", Res.string.banko_for_players)
  map.put("banko_for_selected_players", Res.string.banko_for_selected_players)
  map.put("banko_plus_active", Res.string.banko_plus_active)
  map.put("banko_plus_annual_with_price", Res.string.banko_plus_annual_with_price)
  map.put("banko_plus_badge", Res.string.banko_plus_badge)
  map.put("banko_plus_banner", Res.string.banko_plus_banner)
  map.put("banko_plus_current_plan", Res.string.banko_plus_current_plan)
  map.put("banko_plus_monthly_plan", Res.string.banko_plus_monthly_plan)
  map.put("banko_plus_plan_unknown", Res.string.banko_plus_plan_unknown)
  map.put("banko_plus_status_note", Res.string.banko_plus_status_note)
  map.put("banko_plus_status_title", Res.string.banko_plus_status_title)
  map.put("banko_plus_unlocks_game_length", Res.string.banko_plus_unlocks_game_length)
  map.put("banko_plus_with_price", Res.string.banko_plus_with_price)
  map.put("banko_plus_yearly_plan", Res.string.banko_plus_yearly_plan)
  map.put("banko_rules_title", Res.string.banko_rules_title)
  map.put("banko_title", Res.string.banko_title)
  map.put("benefit_host_length", Res.string.benefit_host_length)
  map.put("benefit_lobby_ad_free", Res.string.benefit_lobby_ad_free)
  map.put("benefit_own_ads", Res.string.benefit_own_ads)
  map.put("benefit_plus_dice", Res.string.benefit_plus_dice)
  map.put("benefit_plus_everything", Res.string.benefit_plus_everything)
  map.put("benefit_silver_dice", Res.string.benefit_silver_dice)
  map.put("biggest_bust", Res.string.biggest_bust)
  map.put("biggest_pot", Res.string.biggest_pot)
  map.put("boldest_bank", Res.string.boldest_bank)
  map.put("bust_risk_description", Res.string.bust_risk_description)
  map.put("bust_risk_live", Res.string.bust_risk_live)
  map.put("bust_risk_safe", Res.string.bust_risk_safe)
  map.put("cancel", Res.string.cancel)
  map.put("career_avg_score", Res.string.career_avg_score)
  map.put("career_best_bank", Res.string.career_best_bank)
  map.put("career_best_score", Res.string.career_best_score)
  map.put("career_best_streak", Res.string.career_best_streak)
  map.put("career_bust_rate", Res.string.career_bust_rate)
  map.put("career_device_note", Res.string.career_device_note)
  map.put("career_empty_body", Res.string.career_empty_body)
  map.put("career_empty_title", Res.string.career_empty_title)
  map.put("career_form_hint", Res.string.career_form_hint)
  map.put("career_games", Res.string.career_games)
  map.put("career_history_margin", Res.string.career_history_margin)
  map.put("career_history_meta_local", Res.string.career_history_meta_local)
  map.put("career_history_meta_online", Res.string.career_history_meta_online)
  map.put("career_history_place", Res.string.career_history_place)
  map.put("career_history_win", Res.string.career_history_win)
  map.put("career_history_winner", Res.string.career_history_winner)
  map.put("career_luck_doubles", Res.string.career_luck_doubles)
  map.put("career_luck_fair", Res.string.career_luck_fair)
  map.put("career_luck_needs_rolls", Res.string.career_luck_needs_rolls)
  map.put("career_luck_sevens", Res.string.career_luck_sevens)
  map.put("career_luck_verdict_fair", Res.string.career_luck_verdict_fair)
  map.put("career_luck_verdict_lucky", Res.string.career_luck_verdict_lucky)
  map.put("career_luck_verdict_unlucky", Res.string.career_luck_verdict_unlucky)
  map.put("career_reset", Res.string.career_reset)
  map.put("career_reset_cancel", Res.string.career_reset_cancel)
  map.put("career_reset_confirm", Res.string.career_reset_confirm)
  map.put("career_reset_message", Res.string.career_reset_message)
  map.put("career_reset_title", Res.string.career_reset_title)
  map.put("career_rival_record", Res.string.career_rival_record)
  map.put("career_rivals_empty", Res.string.career_rivals_empty)
  map.put("career_rivals_legend_them", Res.string.career_rivals_legend_them)
  map.put("career_rivals_legend_you", Res.string.career_rivals_legend_you)
  map.put("career_scores_legend_other", Res.string.career_scores_legend_other)
  map.put("career_scores_legend_win", Res.string.career_scores_legend_win)
  map.put("career_scores_selected", Res.string.career_scores_selected)
  map.put("career_section_form", Res.string.career_section_form)
  map.put("career_section_history", Res.string.career_section_history)
  map.put("career_section_luck", Res.string.career_section_luck)
  map.put("career_section_placements", Res.string.career_section_placements)
  map.put("career_section_rivals", Res.string.career_section_rivals)
  map.put("career_section_scores", Res.string.career_section_scores)
  map.put("career_section_style", Res.string.career_section_style)
  map.put("career_style_body", Res.string.career_style_body)
  map.put("career_style_scale_high", Res.string.career_style_scale_high)
  map.put("career_style_scale_low", Res.string.career_style_scale_low)
  map.put("career_win_rate", Res.string.career_win_rate)
  map.put("career_win_streak", Res.string.career_win_streak)
  map.put("career_wins", Res.string.career_wins)
}
